import React from 'react';

const Dashboard = () => {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold">Welcome to the Admin Dashboard</h2>
    </div>
  );
};

export default Dashboard;
